import styled from 'styled-components'
import { limitLines } from 'src/styles'

export const Title = styled.h3`
  ${limitLines(2)}
`

Title.displayName = 'Title'

export const Text = styled.p`
  ${limitLines(2)}
`

Text.displayName = 'Text'

export const ProgressText = styled.span`
  font-size: 0.625rem;
`

ProgressText.displayName = 'ProgressText'

export const ProgressBar = styled.progress`
  height: 0.625rem;
  appearance: none;
  border-radius: var(--border-radius-lg);

  ::-webkit-progress-bar {
    background-color: var(--gray-200);
    border-radius: var(--border-radius-lg);
  }

  ::-webkit-progress-value {
    background-color: var(--blue-light);
    border-radius: var(--border-radius-lg);
  }

  ::-moz-progress-bar {
    background-color: var(--blue-light);
    border-radius: var(--border-radius-lg);
  }
`

ProgressBar.displayName = 'ProgressBar'
